import {
  Modal,
  Skeleton,
  Form,
  Input,
  Radio,
  RadioChangeEvent,
  DatePicker,
  Select,
  Card,
} from "antd";
import PhoneInput from "react-phone-input-2";
import dayjs from "dayjs";
import "dayjs/locale/pt-br"; // Caso queira suportar o formato em português
import customParseFormat from "dayjs/plugin/customParseFormat";

import {
  formStyle,
  layout,
  formStyleRepresentante,
  buttonOk,
  buttonCancel,
  Title,
} from "../styles";

import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useError } from "../../../uteis/mensagens/useError";
import { useSuccess } from "../../../uteis/mensagens/useSuccess";
import { useAdicionarRepresentante } from "../hooks/useAdicionarRepresentante";
import { MaskedInput } from "antd-mask-input";
import { usePaises } from "../hooks/usePaises";
import { estadoCivil } from "../constantes/estadoCivilOptions";
import { filterOption, filterSort } from "../../../uteis/filtroSelect";
import { useEstado } from "../hooks/useEstado";
import { useCidade } from "../hooks/useCidade";
import { useMessage } from "../../../uteis/mensagens/useMessage";

interface PropsModal {
  isModalOpen: boolean;
  handleFechar: () => void;
  cotaUsuarioId?: number | null;
}
export default function ModalAdicionarRepresentante({
  isModalOpen,
  handleFechar,
  cotaUsuarioId,
}: PropsModal) {
  dayjs.extend(customParseFormat);
  const [representanteForm] = Form.useForm();
  const [usuarioForm] = Form.useForm();
  // UseStates necessários
  const [check, setCheck] = useState<number>();
  const [active, setActive] = useState<number>();
  const [phone, setPhone] = useState("");

  const [selectedEstado, setSelectedEstado] = useState<number>();

  // Estado inicial de Representante
  const [representanteData, setRepresentanteData] = useState<any>({});

  // Estado inicial de Usuario
  const [usuarioData, setUsuarioData] = useState<any>({});

  // Função que armazena o dado selecionado de checkado
  const checkChange = (e: RadioChangeEvent) => {
    setCheck(e.target.value);
  };
  const activeChange = (e: RadioChangeEvent) => {
    setActive(e.target.value);
  };
  const handlePhoneChange = (value: string) => {
    setPhone(value);
  };
  const usuarioChange = (changedValues: Partial<any>, allValues: any) => {
    setUsuarioData((prevState: any) => ({
      ...prevState, // Mantém o estado atual
      ...allValues, // Atualiza com os valores do formulário
    }));
  };
  const representanteChange = (changedValues: Partial<any>, allValues: any) => {
    setRepresentanteData(allValues);
  };

  const paisChange = (value: any) => {
    // Encontrar o país correspondente ao valor selecionado
    const paisSelecionado = paises.find((pais) => pais.abreviacao === value);

    // Verificar se encontrou o país
    if (paisSelecionado) {
      setUsuarioData((prevState: any) => ({
        ...prevState,
        paisId: paisSelecionado.id,
      }));
    }
  };

  //Função que armazena no state o estado selecionado
  const handleEstadoChange = (value: number) => {
    setSelectedEstado(value);

    usuarioForm.setFieldsValue({ cidadeId: undefined }); // Limpa o valor da cidade no formulário específico
  };

  const { isLoading, paises } = usePaises(isModalOpen);
  const { isLoading: isLoadingEstado, estados } = useEstado(isModalOpen);
  const { isLoading: isLoadingCidade, cidades } = useCidade(
    isModalOpen,
    selectedEstado
  );

  const {
    adicionarRepre,
    isLoading: isLoadingAdicionar,
    error,
    success,
    resetError,
  } = useAdicionarRepresentante();

  // Exibe a Mensagem de  Feedback
  const { showSuccess, showError, contextHolder } = useMessage();

  // Estado para controlar se o erro já foi exibido
  const [errorDisplayed, setErrorDisplayed] = useState(false);

  // Estado para controlar se o sucesso já foi exibido
  const [successDisplayed, setSuccessDisplayed] = useState(false);

  // Hook de navegação do React Router
  const navigate = useNavigate();
  useEffect(() => {
    if (isModalOpen && success && !successDisplayed) {
      // Mensagem de sucesso
      const msgSuccess = "Representante cadastrado com Sucesso!";
      showSuccess(msgSuccess);
      setSuccessDisplayed(true);

      // Limpa sucesso após 3 segundos
      setTimeout(() => {
        navigate(0);
      }, 2000);
    }

    if (isModalOpen && error && !errorDisplayed) {
      // Mensagem de erro
      let msgError = "Não foi possível cadastrar o representante!";
      showError(msgError);
      setErrorDisplayed(true);

      // Limpa erro após 3 segundos
      setTimeout(() => {
        setErrorDisplayed(false);
        resetError();
      }, 3000);
    }

    // Reset quando o modal fecha
    if (!isModalOpen) {
      setSuccessDisplayed(false);
      setErrorDisplayed(false);
    }
  }, [
    isModalOpen,
    success,
    error,
    showSuccess,
    showError,
    successDisplayed,
    errorDisplayed,
    resetError,
    navigate,
  ]);

  return (
    <>
      <Modal
        open={isModalOpen}
        cancelText="Cancelar"
        okText="Adicionar Representante"
        onOk={() =>
          adicionarRepre(representanteData, usuarioData, cotaUsuarioId!)
        }
        confirmLoading={isLoadingAdicionar}
        onCancel={handleFechar}
        okButtonProps={{
          style: buttonOk,
        }}
        cancelButtonProps={{
          style: buttonCancel,
        }}
      >
        {isLoading && isLoadingEstado && isLoadingCidade && <Skeleton active />}
        {!isLoading && !isLoadingEstado && !isLoadingCidade && (
          <Card
            title={<Title>Representante</Title>}
            style={{
              width: "100%",
              marginTop: "20px",
              borderRadius: "10px",
              boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
            }}
          >
            <>{contextHolder}</>
            <Form
              {...layout}
              form={usuarioForm}
              initialValues={usuarioData}
              onValuesChange={(changedValues, allValues) =>
                usuarioChange(changedValues, allValues)
              }
              name="representante-usuario"
              //style={formStyle}
            >
              <Form.Item name={["nome"]} label="Nome " className="formItems">
                <Input />
              </Form.Item>
              <Form.Item
                name={["sobrenome"]}
                label="Sobrenome "
                className="formItems"
              >
                <Input />
              </Form.Item>
              <Form.Item
                name={["cpf"]}
                label="CPF"
                rules={[{ required: true }]}
                className="formItems"
              >
                <MaskedInput mask="000.000.000-00" />
              </Form.Item>
              <Form.Item
                name={["rg"]}
                label="RG"
                rules={[{ required: true }]}
                className="formItems"
              >
                <Input placeholder="Digite seu RG" />
              </Form.Item>
              <Form.Item name={["email"]} label="Email " className="formItems">
                <Input />
              </Form.Item>

              <Form.Item
                name="celular"
                label="Celular"
                className="formItems"
                getValueFromEvent={(value) => value} // Garante que o valor do PhoneInput seja capturado corretamente
              >
                <PhoneInput
                  country={"br"}
                  value={phone}
                  onChange={handlePhoneChange}
                  placeholder="Digite seu telefone"
                  inputClass="phone-input"
                />
              </Form.Item>
              <Form.Item
                name={["nacionalidade"]}
                label="Nacionalidade"
                rules={[{ required: true }]}
                className="formItems"
              >
                <Select
                  onChange={paisChange}
                  placeholder="Selecione a nacionalidade"
                >
                  {paises.map((pais) => (
                    <Select.Option key={pais.id} value={pais.abreviacao}>
                      {pais.nome}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
              <Form.Item
                name={["estadoCivil"]}
                label="Estado Civil"
                rules={[{ required: true }]}
                className="formItems"
              >
                <Select>
                  {estadoCivil.map((ec, index) => (
                    <Select.Option key={ec.id} value={ec.value}>
                      {ec.label}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
              <Form.Item
                name={["endereco"]}
                label="Endereço"
                rules={[{ required: true }]}
                className="formItems"
              >
                <Input />
              </Form.Item>
              <Form.Item
                name={["complemento"]}
                label="Complemento"
                rules={[{ required: true }]}
                className="formItems"
              >
                <Input />
              </Form.Item>

              <Form.Item
                name={["estadoId"]}
                label="Estado"
                rules={[{ required: true }]}
                className="formItems"
              >
                <Select
                  showSearch
                  placeholder="Selecione o estado"
                  onChange={(value) => handleEstadoChange(value)}
                  filterOption={filterOption}
                  filterSort={filterSort}
                >
                  {estados.map((estado) => (
                    <Select.Option
                      key={estado.id}
                      value={estado.id}
                      label={estado.nome}
                    >
                      {estado.nome}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
              <Form.Item
                name={["cidadeId"]}
                label="Cidade"
                rules={[{ required: true }]}
                className="formItems"
              >
                <Select
                  showSearch
                  placeholder="Selecione a cidade"
                  optionFilterProp="children"
                  filterOption={filterOption}
                  filterSort={filterSort}
                >
                  {cidades.map((cidade) => (
                    <Select.Option
                      key={cidade.id}
                      value={cidade.id}
                      label={cidade.nome}
                    >
                      {cidade.nome}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </Form>
            {/* Representante */}
            <Form
              {...layout}
              form={representanteForm}
              initialValues={representanteData}
              onValuesChange={(changedValues, allValues) =>
                representanteChange(changedValues, allValues)
              }
              name="representante"
              //style={formStyleRepresentante}
            >
              <Form.Item
                name={["created_at"]}
                label="Data inclusão "
                className="formItems"
              >
                <DatePicker format="DD/MM/YYYY" />
              </Form.Item>

              <Form.Item
                name={["dataAssinatura"]}
                label="Data assinatura "
                className="formItems"
              >
                <DatePicker format="DD/MM/YYYY" />
              </Form.Item>
              <Form.Item
                name={["dataVencimento"]}
                label="Data vencimento "
                className="formItems"
              >
                <DatePicker format="DD/MM/YYYY" />
              </Form.Item>
              <Form.Item
                name={["checked"]}
                label="Check "
                className="formItems"
              >
                <Radio.Group onChange={checkChange} value={check}>
                  <Radio value={0}>Não Checked</Radio>
                  <Radio value={1}>Checked</Radio>
                </Radio.Group>
              </Form.Item>
              <Form.Item name={["active"]} label="Ativo " className="formItems">
                <Radio.Group onChange={activeChange} value={active}>
                  <Radio value={0}>Desativar</Radio>
                  <Radio value={1}>Ativar</Radio>
                </Radio.Group>
              </Form.Item>
            </Form>
          </Card>
        )}
      </Modal>
    </>
  );
}
